import ResumeSidebarComponent from "./ResumeSidebar";

export default ResumeSidebarComponent;
